'use strict';

/** @typedef {'en'|'fr'} PrivacyRequestLanguage */

function resolvePrivacyRequestLanguage(documentLang) {
	if (typeof documentLang === 'string' && documentLang.toLowerCase().startsWith('fr')) {
		return 'fr';
	}

	return 'en';
}

const PRIVACY_REQUEST_COPY = {
	en: {
		bannerNotOptedOutTitle: 'You have not opted out on this browser.',
		bannerNotOptedOutBody: 'Your choices are saved to this browser. If you use another browser or another device, make your choices there as well.',
		bannerOptedOutTitle: 'You have opted out of the sale or sharing of your personal information on this browser.',
		bannerOptedOutBody: 'Your choices are saved to this browser. If you use another browser or another device, make your choices there as well.',
		bannerGpcTitle: 'We detected a Global Privacy Control signal from your browser and processed it as an opt-out of the sale or sharing of your personal information.',
		bannerGpcBody: 'This applies to this browser for as long as the signal is sent. If you use another browser or another device, make your choices there as well.',
		optOutButton: 'Opt Out From Sharing My Personal Info',
		manageCookieSettings: 'Manage Cookie Settings',
		gpcDescription: 'If your browser sends a Global Privacy Control (GPC) signal, we honor it as a request to opt out of the sale or sharing of personal information through non-essential cookies on this browser. The categories affected depend on how this store is configured.',
	},
	fr: {
		bannerNotOptedOutTitle: 'Vous n\'avez pas refusé le partage dans ce navigateur.',
		bannerNotOptedOutBody: 'Vos choix sont enregistrés dans ce navigateur. Si vous utilisez un autre navigateur ou un autre appareil, faites aussi vos choix là-bas.',
		bannerOptedOutTitle: 'Vous avez refusé la vente ou le partage de vos renseignements personnels dans ce navigateur.',
		bannerOptedOutBody: 'Vos choix sont enregistrés dans ce navigateur. Si vous utilisez un autre navigateur ou un autre appareil, faites aussi vos choix là-bas.',
		bannerGpcTitle: 'Nous avons détecté un signal de contrôle de la confidentialité globale (GPC) et l\'avons traité comme un refus de la vente ou du partage de vos renseignements personnels.',
		bannerGpcBody: 'Cela s\'applique à ce navigateur tant que le signal est envoyé. Si vous utilisez un autre navigateur ou un autre appareil, faites aussi vos choix là-bas.',
		optOutButton: 'Refuser le partage de mes renseignements personnels',
		manageCookieSettings: 'Gérer les paramètres des témoins',
		gpcDescription: 'Si votre navigateur envoie un signal de contrôle de la confidentialité globale (GPC), nous l\'honorons comme une demande de refus de la vente ou du partage de renseignements personnels par l\'entremise de témoins non essentiels dans ce navigateur. Les catégories touchées dépendent de la configuration de cette boutique.',
	},
};

module.exports = {
	PRIVACY_REQUEST_COPY,
	resolvePrivacyRequestLanguage,
};
